// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_3SCF5qIujNYCaTU3_zG4b1"};